import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ListContainer = ({
  title,
  onClose,
  filterBar,
  footer,
  children
}) => {
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const navigate = useNavigate();

  const handleBack = () => {
    if (onClose) {
      onClose();
    } else {
      navigate('/home');
    }
  };

  return (
    <div className="form-container-card" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Fixed Header */}
      <header className="form-container-header" style={{ borderBottom: '1px solid #e0e5f2' }}>
        <div className="form-container-title-group">
          <button
            type="button"
            className="form-container-back-btn"
            onClick={handleBack}
            aria-label="Back"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
          </button>
          <h2 className="form-container-title" style={{ fontSize: '18px', fontWeight: '700', color: '#1b2559', margin: 0 }}>
            {title}
          </h2>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {/* Mobile Filter Toggle Button */}
          {filterBar && (
            <button
              type="button"
              className="list-filter-toggle-btn"
              onClick={() => setShowMobileFilters(!showMobileFilters)}
              aria-label="Toggle Filters"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
              </svg>
            </button>
          )}

          {onClose && (
            <button
              type="button"
              className="form-container-close"
              onClick={onClose}
              aria-label="Close"
            >
              ✕
            </button>
          )}
        </div>
      </header>

      {/* Filter Bar */}
      {filterBar && (
        <div className={`list-filter-bar ${showMobileFilters ? 'mobile-open' : ''}`}>
          {filterBar}
        </div>
      )}

      {/* Middle Scrollable Content */}
      <div className="form-container-body" style={{ flex: 1, overflowY: 'auto', padding: '24px' }}>
        {children}
      </div>

      {/* Fixed Footer */}
      {footer && (
        <footer className="form-container-footer" style={{ padding: '16px 24px', borderTop: '1px solid #e0e5f2', background: '#ffffff' }}>
          {footer}
        </footer>
      )}
    </div>
  );
};

export default ListContainer;
